import { Navigate } from 'react-router-dom';

import { useFeatureFlagSplit } from '../../hooks/useFeatureFlagSplit';

export interface FeatureFlagProtectedRouteProps {
  element: JSX.Element;
  featureFlag: string;
  fallbackPath?: string;
  replace?: boolean;
}

/**
 * Guards a route element behind a feature flag. When the flag is disabled,
 * the user is redirected to the provided fallback path.
 */
export const FeatureFlagProtectedRoute = ({
  element,
  featureFlag,
  fallbackPath = '/',
  replace = true,
}: FeatureFlagProtectedRouteProps) => {
  const isEnabled = useFeatureFlagSplit(featureFlag, false) as boolean;

  if (isEnabled) {
    return element;
  }

  return <Navigate to={fallbackPath} replace={replace} />;
};
